module.exports = __webpack_public_path__ + "img/coming_home.5d3fcf87.svg";